
import { Options, prop, Vue } from "vue-class-component";

class Props {
  modelValue = prop({ type: String, default: "" });
}

@Options({
  emits: ["update:modelValue"]
})
export default class SelectHours extends Vue.with(Props) {
  isHoursVisible = false;
  get iconHours() {
    return this.isHoursVisible ? "chevron-up" : "chevron-down";
  }
  openHours(event: any) {
    const refs: any = this.$refs;
    refs?.opHours?.toggle(event);
  }
  selectHours(event: Event, value: number) {
    this.$emit("update:modelValue", `${String(value).padStart(2, "0")}:00`);

    const refs: any = this.$refs;
    refs?.opHours?.hide(event);
  }
  isSelectedHours(value: number) {
    return this.modelValue === `${String(value).padStart(2, "0")}:00`;
  }

  scrollToActiveHour() {
    this.$nextTick(() => {
      const op: any = this.$refs.opHours;
      const overlayEl =
        op?.container || op?.$el || (op?.$?.vnode?.el as HTMLElement);

      if (!overlayEl) return;

      const active = overlayEl.querySelector(".hours-active");
      active?.scrollIntoView({ block: "center", behavior: "smooth" });
    });
  }

  mounted() {
    const op: any = (this.$refs as any)?.opHours;
    if (op) {
      op.$watch("visible", (val: boolean) => {
        this.$nextTick(() => {
          this.isHoursVisible = val;

          if (val) this.scrollToActiveHour(); // 👈 auto-scroll when opened
        });
      });
    }
  }
}
